export default __webpack_public_path__ + "static/Writing-with-GEM-v1-a0113ad41c3c4bb5bc59539a1547671d.mp4";